module.exports = __webpack_public_path__ + "img/selected7-min.806cea25.png";